import React, { useEffect, useState } from "react";
import "./Product_Description.css";
import Product_Inner_Description from "./product_inner_description/Product_Inner_Description";
import Product_Image from "./product_image/Product_Image";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import TopReviews from "./top_reviews/TopReviews";
import Similar_Products from "./similar_products/Similar_Products";
import You_May_Also_Like from "./you_may_also_like/You_May_Also_Like";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProducts,
  getAllProductsAlsoLike,
  getProduct,
} from "../../features/products/productsSlice";
import { decodeId, encodeId } from "../../utils/common";
import {
  AvgReviewRating,
  getAllReview,
} from "../../features/review_rating/review_ratingSlice";

const Product_Description = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  const product = useSelector((state) => state.product.product);

  useEffect(() => {
    const decodId = decodeId(id);
    dispatch(getProduct(decodId));
  }, [dispatch, id]);

  const allSimilarProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    dispatch(
      getAllProducts({
        category_id: product?.p_category_id,
        subcategory_id: product?.p_sub_category_id,
        childcategory_id: product?.p_child_category_id,
      })
    );
  }, [dispatch, product]);

  const You_May_Also_LikeProduct = useSelector(
    (state) => state.product.allProductsAlsoLike
  );
  useEffect(() => {
    dispatch(
      getAllProductsAlsoLike({
        category_id: product?.p_category_id,
      })
    );
  }, [dispatch, product]);

  const all_review = useSelector((state) => state.reviewRating.all_review);
  useEffect(() => {
    dispatch(getAllReview({ id: product?.id }));
  }, [dispatch, product]);

  const avgrating = useSelector((state) => state.reviewRating.avg_rating);
  useEffect(() => {
    dispatch(AvgReviewRating({ product_id: product?.id }));
  }, [dispatch, product]);

  return (
    <section className="Product_Description">
      <Breadcrumb_comp
        breadcrumbs={[
          { label: "Home", link: "/", isActive: false },
          {
            label: product?.p_category?.name,
            link: `/product-listing/${
              product?.p_category_id
            }?category_image=${encodeURIComponent(product?.p_category?.image)}`,
            isActive: false,
          },
          { label: product?.name, link: "", isActive: true },
        ]}
        additionalClass="groceries"
      />

      <div className="container">
        <div className="product_description_container">
          <div className="product_information">
            <div className="row justify-content-center">
              <div className="col-lg-5 col-md-8 col-12">
                {product ? <Product_Image image={product} /> : <></>}
              </div>

              <div className="col-lg-7 col-md-12">
                <Product_Inner_Description
                  avgrating={avgrating}
                  product={product}
                />
              </div>
            </div>
          </div>

          <div className="similar_products_div">
            <Similar_Products product={allSimilarProducts} />
          </div>
          {all_review?.length > 0 && (
            <div className="top_3_review_section">
              <TopReviews all_review={all_review} />
            </div>
          )}

          <div className="you_may_also_div">
            <You_May_Also_Like data={You_May_Also_LikeProduct} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product_Description;
